import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'searchPipe'
})
export class SearchPipePipe implements PipeTransform {
    items: any;

    transform(value, arg, ...type) {
        if (!arg) {
            return value;
        }

        if (value !== undefined) {
            const items = value.filter(item => {
                let res = false;
                type.map(option => {
                    if (item[option].toLowerCase().includes(arg.toLowerCase())) {
                        res = true;
                    }
                });
                return res;
            });
            return items;
        }

    }

}
